import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialog } from '@angular/material/dialog';
import { User } from '../model/user';
import { UserService } from '../services/user.service';
import { AuthenticationService } from '../services/authentication.service';
import { getStoredUser } from '../helpers/user-storage.util';
import { AliasVendorPickerDialogComponent } from '../alias/alias-vendor-picker-dialog/alias-vendor-picker-dialog.component';

// Dedicated header for /internal/* routes, split out of the shared legacy
// `page-header` (header/header.component.ts) so the internal console no
// longer depends on the dual-purpose component. Reproduces the internal
// branch of that component (logo, internal nav link, My Account menu with
// logout) verbatim — internal is out of CONNECT 2.0 restyle scope.
@Component({
  standalone: true,
  selector: 'app-internal-header',
  imports: [RouterLink, CommonModule, MatMenuModule],
  templateUrl: './internal-header.component.html',
  styleUrl: './internal-header.component.scss',
})
export class InternalHeaderComponent implements OnInit {
  userProfilePic: String = '';
  user: User = {};

  /** Grants access to the "Alias User" action — an internal staffer's stored permission flag. */
  get canAlias(): boolean {
    return getStoredUser().canAlias === true;
  }

  constructor(
    private userService: UserService,
    private authenticationService: AuthenticationService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    // Read through getStoredUser() rather than parsing the 'user' key directly:
    // it unwraps a legacy `{ data: User }` value (which would otherwise render an
    // empty profile here), falls back to sessionStorage, and never throws.
    this.user = getStoredUser();
    if (this.user.photo) {
      this.userProfilePic = this.user.photo;
    }
    this.userService.getUser().subscribe((user) => {
      if (user) {
        this.userProfilePic = user.photo;
      }
    });
  }

  logout(): void {
    this.authenticationService.logout();
  }

  openAliasPicker(): void {
    this.dialog.open(AliasVendorPickerDialogComponent, { width: '560px' });
  }
}
